import { memo, useMemo } from 'react';
import clsx from 'clsx';
import { ListItem, type ListItemProps, ListItemText, styled } from '@mui/material';

import { Icon } from 'app/main/components';
import withRouter from '@fuse/core/withRouter';
import FuseNavBadge from '../../FuseNavBadge';
import type { FuseNavProps } from '../../types/FuseNavProps';

interface StyledListItemProps extends ListItemProps {
	href?: string;
	target?: string;
}

const StyledListItem = styled(ListItem)<StyledListItemProps>(({ theme }) => ({
	color: theme.palette.text.primary,
	textDecoration: 'none!important',
	minHeight: 48,
	'&.active': {
		backgroundColor: `${theme.palette.secondary.main}!important`,
		color: `${theme.palette.secondary.contrastText}!important`,
		pointerEvents: 'none',
		'& .fuse-list-item-text-primary': {
			color: 'inherit'
		},
		'& .fuse-list-item-icon': {
			color: 'inherit'
		}
	},
	'& .fuse-list-item-icon': {},
	'& .fuse-list-item-text': {
		padding: '0 0 0 16px'
	}
}));

function FuseNavHorizontalLink(props: FuseNavProps) {
	const { item } = props;

	return useMemo(
		() => (
			<StyledListItem
				component="a"
				href={item.url}
				target={item.target ? item.target : '_blank'}
				className={clsx('fuse-list-item')}
				role="button"
			>
				{item.icon && (
					<Icon
						icon={item.icon}
						className={clsx('fuse-list-item-icon shrink-0 text-16', item.iconClass)}
						color="action"
					/>
				)}

				<ListItemText
					className="fuse-list-item-text"
					primary={item.title}
					classes={{ primary: 'text-13 fuse-list-item-text-primary' }}
				/>

				{item.badge && <FuseNavBadge className="ltr:ml-8 rtl:mr-8" badge={item.badge} />}
			</StyledListItem>
		),
		[item.badge, item.icon, item.iconClass, item.target, item.title, item.url]
	);
}

const NavHorizontalLink = withRouter(memo(FuseNavHorizontalLink));

export default NavHorizontalLink;
